import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { Popover } from '../Popover/Popover';
import { PopoverContainer } from '../Popover/PopoverContainer';
import Svg from '../Svg';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "PopoverIcon-root_2DxRB",
  "icon": "PopoverIcon-icon_1XNwb"
};
const iconToIntent = {
  infoWire: 'info',
  successWire: 'success',
  warningWire: 'warning',
  dangerWire: 'danger',
  questionWire: 'info'
};
function PopoverIcon({
  id,
  visible,
  placement,
  modifiers,
  behaviour,
  interactive,
  icon,
  iconTheme,
  title,
  popoverIntent,
  children,
  className,
  referenceProps
}) {
  const computedIconTheme = iconTheme || iconToIntent[icon];
  const computedPopoverIntent = popoverIntent || iconToIntent[icon];
  return /*#__PURE__*/_jsx(PopoverContainer, {
    id: id,
    visible: visible,
    placement: placement,
    modifiers: modifiers,
    behaviour: behaviour,
    interactive: interactive,
    renderReference: getReferenceProps => {
      const {
        innerRef,
        ...restProps
      } = getReferenceProps(referenceProps);
      return /*#__PURE__*/_jsx(Base, {
        tagName: "button",
        type: "button",
        flexInline: true,
        border: "none",
        backgroundColor: "transparent",
        className: clsx(styles.root, className),
        ...restProps,
        children: /*#__PURE__*/_jsx(Base, {
          tagName: "span",
          flexInline: true,
          innerRef: innerRef,
          children: /*#__PURE__*/_jsx(Svg, {
            name: icon,
            theme: computedIconTheme,
            className: styles.icon
          })
        })
      });
    },
    children: getPopoverProps => /*#__PURE__*/_jsx(Popover, {
      title: title,
      intent: computedPopoverIntent,
      ...getPopoverProps(),
      children: children
    })
  });
}
export default PopoverIcon;